import React, { Fragment, useEffect, useState } from 'react'

import { Row, Col } from 'reactstrap'
import SideBar from '../../components/SideBar'

import { getDashboardStatsApi } from '../../api/dashboard'

import ManifestStrip from '../../components/Home/ManifestStrip'
import Panel from '../../components/Home/Panel'
import StatusRing from '../../components/Home/Chart/StatusRing'
import MonthlyVolume from '../../components/Home/Chart/MonthlyVolume'
import TopRoutes from '../../components/Home/Chart/TopRoutes'
import FleetComposition from '../../components/Home/Chart/FleetComposition'
import RegistryQueue from '../../components/Home/Chart/RegistryQueue'

function Home() {
    const [stats, setStats] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        getStats()
        // eslint-disable-next-line
    }, [])

    const getStats = async () => {
        try {
            setIsLoading(true)
            setHasError(false)

            const response = await getDashboardStatsApi()

            if(!response) {
                setHasError(true)
                return
            }

            setStats(response)
        }
        catch(err) {
            setHasError(true)
        }
        finally {
            setIsLoading(false)
        }
    }

    const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })

  return (
    <Fragment>
        <section className='Home_page'>
            <div className="contents">
                <Row>
                    <Col md="2" className='p-0'>
                        <SideBar />
                    </Col>
                    <Col md="10" className='p-0'>
                        <div className="dashboardContent">
                            <div className="dashboardHeader">
                                <span className="eyebrow">Tableau de bord</span>
                                <h1>Suivi des opérations</h1>
                                <span className="today">{today}</span>
                            </div>

                            {isLoading && (
                                <p className="stateMessage">Chargement des données…</p>
                            )}

                            {!isLoading && hasError && (
                                <p className="stateMessage error">Impossible de charger les données du tableau de bord. Réessayez dans un instant.</p>
                            )}

                            {!isLoading && !hasError && stats && (
                                <Fragment>
                                    <ManifestStrip totals={stats.totals} />

                                    <Panel eyebrow="À traiter" title="File d'attente d'homologation" className="queuePanel">
                                        <RegistryQueue data={stats.registryStatus} />
                                    </Panel>

                                    <div className="chartsGrid">
                                        <Panel eyebrow="Aujourd'hui" title="Statut des opérations">
                                            <StatusRing data={stats.operationsByStatus} />
                                        </Panel>

                                        <Panel eyebrow="6 derniers mois" title="Volume mensuel">
                                            <MonthlyVolume data={stats.tripsByMonth} />
                                        </Panel>

                                        <Panel eyebrow="6 derniers mois" title="Itinéraires fréquents">
                                            <TopRoutes routes={stats.topRoutes} />
                                        </Panel>

                                        <Panel eyebrow="En service" title="Composition de la flotte">
                                            <FleetComposition fleet={stats.fleetByMarque} />
                                        </Panel>
                                    </div>
                                </Fragment>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    </Fragment>
  )
}

export default Home
